export default __webpack_public_path__ + "static/media/clock.df87d96e.png";